<div
  *ngIf="model?.verified"
  class="inline-block ml-1 text-blue-500"
  [style.width.px]="size"
  [style.height.px]="size"
  fit-text
  [minFontSize]="size * 0.6"
  [maxFontSize]="size * 0.6"
>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 50 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill: currentColor;
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <path
      d="M25,1C38.246,1 49,11.754 49,25C49,38.246 38.246,49 25,49C11.754,49 1,38.246 1,25C1,11.754 11.754,1 25,1ZM41.447,15.061L36.706,10.912L20.049,29.949C20.049,29.949 13.003,22.902 13.003,22.902L8.548,27.357L20.356,39.165L41.447,15.061Z"
    />
  </svg>
</div>

<style>
  :host {
    display: inline-flex;
    vertical-align: middle;
    align-items: center;
  }

  :host:empty {
    display: none;
  }
</style>
